import { lazy } from "react";

export default [
  {
    exact: true,
    path: "/:customerName/classroom/courses/",
    component: lazy(
      () => import("src/views/arkadu/classroom/ClassroomCoursesIndex"),
    ),
  },
  {
    exact: true,
    path: "/:customerName/classroom/courses/:courseId/",
    component: lazy(
      () => import("src/views/arkadu/classroom/ClassroomCoursesIndex"),
    ),
  },
  {
    exact: true,
    path: "/:customerName/classroom/compliance/",
    component: lazy(
      () => import("src/views/arkadu/classroom/ComplianceReport"),
    ),
  },
  {
    exact: true,
    path: ["/:customerName/classroom/exams/", "/:customerName/classroom/"],
    component: lazy(() => import("src/views/arkadu/classroom/ClassroomExamIndex")),
  },
];
